import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { Address,  BuildingRegistration,  MarketRentInfo } from '@app/core/stingray-api/models';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BuildingExpectedRentIncomePopupData } from './building-expectedrentincome-popup-data';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass, CurrencyPipe } from '@angular/common';
import { MatList, MatListItem } from '@angular/material/list';

interface ExpectedRentIncomeAttribute {
   name: string;
   isMatched: boolean;
   value: string;
}

@Component({
    selector: 'unite-building-expectedrentincome-popup',
    templateUrl: './building-expectedrentincome-popup.component.html',
    styleUrls: ['./building-expectedrentincome-popup.component.scss'],
    imports: [MatDialogContent, TranslateModule, MatList, MatListItem, NgClass, MatIcon, MatButton, MatDialogClose, CurrencyPipe]
})
export class BuildingExpectedRentIncomePopupComponent {

  marketRentInfo: MarketRentInfo;
  buildingAddress: Address;
  buildingRegistration: BuildingRegistration;

  attributes: ExpectedRentIncomeAttribute[] = [];
  attributeNames = ['street', 'city', 'district', 'surface', 'construction year'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BuildingExpectedRentIncomePopupData,
    private translateService: TranslateService
  ) {

    this.marketRentInfo = data.info;
    this.buildingAddress = data.address;
    this.buildingRegistration = data.building;

    console.log(data);

    for(const name of this.attributeNames) {
      this.attributes.push({
         name: this.translateService.instant(name),
         isMatched: data.info.expectedRentIncomeMatchAttributes.filter(t => t === name).length > 0,
         value: this.getAttributeValue(name)
      });
    }

    /* Matches on top */
    this.attributes = this.attributes.sort((x, y) => (x.isMatched === y.isMatched) ? 0 : x.isMatched ? -1 : 1 );
   }

  private getAttributeValue(name: string): string {
      switch (name) {
        case 'surface':
          return this.buildingRegistration.surface ? this.buildingRegistration.surface.toString() + 'm²' : null;
        case 'street':
          return this.buildingAddress.street;
        case 'city':
          return this.buildingAddress.city;
        case 'district':
          return this.buildingAddress.district;
        case 'construction year':
          return this.buildingRegistration.constructionYear ? this.buildingRegistration.constructionYear.toString() : null;
        default:
          return '';
      }
    }
}
